import { setState } from "@/storage/db";
import {
  SET_LOGIN_FULLNAME,
  SET_LOGIN_USERNAME,
  // SET_CURRENT_CUSTOMER,
  SET_CURRENT_USER,
  RESET_CURRENT_USER,
} from "@/store/modules/security/mutation-types";

import { SET_LOCALE } from "@/store/mutation-types";

const mutationsOfInterest = {
  security: {
    SET_LOGIN_USERNAME,
    SET_LOGIN_FULLNAME,
    SET_CURRENT_USER,
    RESET_CURRENT_USER,
  },
  root: {
    SET_LOCALE,
  },
};

const ofInterest = mutation => {
  const tokens = mutation.split("/");
  if (tokens.length === 1) {
    tokens.unshift("root");
  }

  const [module, type] = tokens;
  return !!(mutationsOfInterest[module] && mutationsOfInterest[module][type]);
};

export default store => {
  store.subscribe((mutation, state) => {
    if (!ofInterest(mutation.type)) {
      return;
    }

    setState(state).catch(err => console.warn("failed to cache state", err));
  });
};
